// true si el user-agent parece Mac/iOS — solo se usa para el LABEL visual
// del atajo de búsqueda global (⌘K vs Ctrl K). Los dos atajos se bindean
// siempre, en cualquier plataforma (ver hooks/use-global-search-shortcut.ts);
// esto es puramente cosmético. `navigator.platform` está deprecado pero
// sigue siendo el chequeo más simple y ampliamente soportado —
// `userAgentData.platform` es Chromium-only. Portado de RISIT tal cual.
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPod|iPad/.test(navigator.platform ?? navigator.userAgent ?? '');
}
